<template>
    <div class="settings-wrapper" v-if="allSettings">
        <div class="section-title">{{ $t('notifications1') }}</div>
        <div class="section-container">
            <div class="section-row">
                <div class="section-info">{{ $t('notifications2') }}</div>
                <div class="section-text">{{ $t('notifications10') }}</div>
                <v-switch
                    v-model="allSettings.bidSettings.hasOffer"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications4') }}</div>
                <div class="section-text">{{ $t('notifications5') }}</div>
                <v-switch
                    v-model="allSettings.bidSettings.hasPortfolio"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications6') }}</div>
                <div class="section-text">{{ $t('notifications7') }}</div>
                <v-switch
                    v-model="allSettings.bidSettings.hasFavorites"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
        </div>

        <div class="section-title">{{ $t('notifications8') }}</div>
        <div class="section-container">
            <div class="section-row">
                <div class="section-info">{{ $t('notifications9') }}</div>
                <div class="section-text">{{ $t('notifications3') }}</div>
                <v-switch
                    v-model="allSettings.offerSettings.hasBid"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications6') }}</div>
                <div class="section-text">{{ $t('notifications7') }}</div>
                <v-switch
                    v-model="allSettings.offerSettings.hasFavorites"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
        </div>

        <div class="section-title">{{ $t('notifications11') }}</div>
        <div class="section-container">
            <div class="section-row">
                <div class="section-info">{{ $t('notifications9') }}</div>
                <div class="section-text">{{ $t('notifications3') }}</div>
                <v-switch
                    v-model="allSettings.matchSettings.hasBid"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications2') }}</div>
                <div class="section-text">{{ $t('notifications10') }}</div>
                <v-switch
                    v-model="allSettings.matchSettings.hasOffer"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications4') }}</div>
                <div class="section-text">{{ $t('notifications5') }}</div>
                <v-switch
                    v-model="allSettings.matchSettings.hasPortfolio"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications6') }}</div>
                <div class="section-text">{{ $t('notifications7') }}</div>
                <v-switch
                    v-model="allSettings.matchSettings.hasFavorites"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
        </div>

        <div class="section-title">{{ $t('notifications12') }}</div>
        <div class="section-container">
            <div class="section-row">
                <div class="section-info">{{ $t('notifications17') }}</div>
                <div class="section-text">{{ $t('notifications16') }}</div>
                <v-switch
                    v-model="allSettings.newWines"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
            <div class="section-row">
                <div class="section-info">{{ $t('notifications13') }}</div>
                <div class="section-text">{{ $t('notifications14') }}</div>
                <v-switch
                    v-model="allSettings.promotions"
                    hide-details
                    color="primary"
                    class="section-switch"
                    @change="saveNotifications"
                ></v-switch>
            </div>
        </div>
        <a class="goto-notifications" href="/notifications">{{ $t('notifications15') }}</a>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {AUser} from '@/store/actions';
    import {GUser} from '@/store/getters';

export default {
    name: "NotificationSettings",
    data() {
        return {
            allSettings: null
        };
    },
    methods: {
        saveNotifications() {
            this.$store.dispatch(AUser.SAVE_NOTIFICATION_SETTINGS, this.allSettings)
        }
    },
    created() {
        this.$store.dispatch(AUser.GET_NOTIFICATION_SETTINGS).then(() => {
            this.allSettings = this.notificationSettings
        })
    },
    computed: {
        ...mapGetters({
            notificationSettings: GUser.GET_NOTIFICATION_SETTINGS
        })
    },
    destroyed() {
        this.saveNotifications()
    }
}
</script>

<style scoped>
.settings-wrapper {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
}

.section-title,
.goto-notifications {
    color: #303030;
    font-weight: 700;
    font-size: 16px;
    line-height: 27px;
    padding-left: 16px;
}

.goto-notifications {
    text-align: right;
    display: block;
    margin-bottom: 50px;
    z-index: 9;
    position: relative;
    padding-top: 12px;
    top: -12px;
}

.section-container {
    border: 1px solid #cccccc;
    border-radius: 10px;
    margin-bottom: 12px;
    background-color: #FFFFFF;
}

.section-row {
    border-bottom: 1px solid #cccccc;
    height: 60px;
    padding: 11px 16px;
    position: relative;
}

.section-container .section-row:last-of-type {
    border-bottom: 0;
}

.section-info {
    color: #000000;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
}

.section-text {
    margin-top: 4px;
    color: #000000;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    opacity: 0.5;
}

.section-switch {
    position: absolute;
    right: 19px;
    top: 0;
}

@media (max-width: 767px) {
    .settings-wrapper {
        margin-top: 30px;
    }

    .goto-notifications {
        text-align: center;
        padding-left: 0;
        margin: 20px auto;
    }

    .section-container {
        background-color: var(--semi-white);
    }
}
</style>
<style>
.v-application .section-switch .primary--text {
    color: #024E7B !important;
    caret-color: #024E7B !important;
}
</style>
